export enum EScrollBannerStatus {
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

export interface IScrollBanner {
  _id: string
  photo: string // 4:1 — приложение и мобильный веб
  photo_desktop: string // 8:1 — ПК-версия сайта
  webUrl: string | null
  // экран приложения бэкенд выводит из webUrl
  navigation_path: string | null
  navigation_params: Record<string, any> | null
  position: number // у закреплённого — место с 1, у остальных — номер в очереди
  fixed_position: boolean
  status: EScrollBannerStatus
  end_date: string | null // «Дата окончания»: после неё баннер уходит в архив
  createdAt: string
  updatedAt: string
}
